// import { isDirty, reset, getFormValues } from 'redux-form';
import { reset, destroy } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions, selectors as operationSelectors } from 'ducks/uiOperations';
import { selectors as pickSlipSelectors, actions as pickSlipActions } from 'ducks/pickSlipEnquiry/pickSlipEnquiries';
import { actions as slipLinesActions } from 'ducks/pickSlipEnquiry/slipLines';
import { actions as bomActions } from 'ducks/pickSlipEnquiry/bom';
import { actions as formActions, selectors as formSelectors } from 'ducks/form';
import { selectors as staffSelectors } from 'ducks/staff';
import { selectors as slipDetailsSelectos, actions as slipDetailsActons } from 'ducks/pickSlipEnquiry/slipDetails';
import PickSlipEnquiry from './PickSlipEnquiry';

const FORM_NAME = 'SlipDetails';

const mapStateToProps = (state) => ({
  operationMode: operationSelectors.operationMode(state),
  selectedPickSlip: pickSlipSelectors.selected(state),
  selectedSupplierSchema: pickSlipSelectors.selectedSchema(state),
  selectedForm: formSelectors.selected(state),
  selectedTab: uiSelectors.selectedTab(state),
  isBrowseLookUpOpen: uiSelectors.isBrowseLookUpOpen(state),
  isMenuOptionOpen: uiSelectors.isMenuOptionOpen(state),
  selectedDespatchId: pickSlipSelectors.selectedDespatchId(state),
  pickSlipDetails: slipDetailsSelectos.slipDetails(state),
  staff: staffSelectors.staff(state),
  isMainMenuOpen: uiSelectors.isMainMenuOpen(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    toggleBrowseLookUp: uiActions.toggleBrowseLookUp,
    changeOperationMode: operationActions.changeOperationMode,
    changeSelectedTab: uiActions.changeSelectedTab,
    getFormSchema: formActions.search,
    changeSelectedForm: formActions.setSelected,
    toggleMenuOption: uiActions.toggleMenuOption,
    resetForm: () => reset(FORM_NAME),
    changeConfirmationDialog: uiActions.changeConfirmationDialog,
    search: pickSlipActions.search,
    searchById: pickSlipActions.searchById,
    getSlipLineDetails: slipLinesActions.fetchSlipLineDetails,
    getSlipLineDetailsSummary: slipLinesActions.fetchSlipLineDetailsSummary,
    getSlipLineBOMDetails: bomActions.fetchDetails,
    getSlipLineBOMDetailsSummary: bomActions.fetchSummary,
    changeSelectedSupplier: pickSlipActions.setSelected,
    closeMenu: uiActions.closeMainMenu,
    fetchSlipDetails: slipDetailsActons.fetch,
    getPickSlipSummary: slipDetailsActons.fetchSummary,
    resetSearchLookupDrawer: pickSlipActions.reset,
    setLookupData: pickSlipActions.setLookupListData,
    destoryForm: () => destroy('PickSlipEnquiry'),
    resetLines: () => reset('SlipLines'),
    resetSummaryPanel: slipDetailsActons.reset,
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PickSlipEnquiry);
